import React from "react";
import "./HeaderTutorial.css";

import logoVidchain from "../../assets/images/vididentity_logo.svg";

function HeaderTutorial () {
    return (
      <header className="headerTutorialBackground">
        <img
          className="logoHeaderTutorial"
          src={logoVidchain}
          alt="Logo"
          onClick={()=> window.location.replace("/demo")}
        />
        <p className="powered">Powered by Validated ID</p>
      </header>
    );
}

export default HeaderTutorial;
